import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar/loading-bar.component';
import { FuseLoadingBarInterceptor } from '@fuse/components/loading-bar/loading-bar.interceptor';
import { GlobalLoadingDisableDirective } from '@fuse/components/loading-bar/global-loading-disable.directive';

@NgModule({
  declarations: [FuseLoadingBarComponent, GlobalLoadingDisableDirective],
  imports: [CommonModule, MatProgressBarModule],
  exports: [FuseLoadingBarComponent, GlobalLoadingDisableDirective],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FuseLoadingBarInterceptor,
      multi: true
    }
  ]
})
export class FuseLoadingBarModule {}
